// Returns a ShA256 hash of the input string
import { sha256 } from "js-sha256";

export function hashInput(input: string | null | object): string {
  try {
    const normalizedInput =
      input === null || input === "" ? "" : JSON.stringify(input);

    const serializedData = sha256(normalizedInput);

    return serializedData;
  } catch (err) {
    console.error("Error serializing string:", err);
    return "";
  }
}
